var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('AddressTemplate',{attrs:{"Address":_vm.CustomerAddress,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }